<template>
  <div class="unauthenticated-layout">
    <div class="logo-container">
      <router-link :to="{ name: 'Dashboard' }"
        ><img src="/images/easy-ticket-logo.svg"
      /></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnauthenticatedLayout",
};
</script>

<style lang="scss" scoped>
.logo-container {
  position: absolute;
  top: 30px;
  left: 30px;
}
</style>
